import {
  default as TooltipModal,
  TooltipContent,
  TooltipHeader,
  TooltipSectionTitle,
} from 'components/Utility/TooltipModal';
import React from 'react';

export function PrepAreaTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Prep Areas</TooltipHeader>
      <TooltipContent>
        <p>
          Prep Areas help you assign where a Product, Category, or Menu is
          prepared in your venue.
        </p>
        <TooltipSectionTitle>Front of House</TooltipSectionTitle>
        <p>
          If you’re viewing your <strong>Live Orders</strong> dashboard on a
          single device in your venue{' '}
          <em>(e.g. a tablet at your front of house)</em>, then use the{' '}
          <strong>Front of House</strong> Prep Area for all items.
        </p>
        <TooltipSectionTitle>Front of House and Kitchen</TooltipSectionTitle>
        <p>
          If there are multiple devices in your venue{' '}
          <em>
            (e.g. a tablet for the kitchen staff, and a tablet for the front of
            house staff)
          </em>
          , then it’s best to assign different Prep Areas to items in your menu.
        </p>
        <p>
          This will split a customer’s order in your{' '}
          <strong>Live Orders</strong> dashboard, so staff can focus on the
          parts of the order that only they need to prepare.
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function StatusTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Status</TooltipHeader>
      <TooltipContent>
        <p>
          Setting a Menu, Category, Product or Choice to <strong>Draft</strong>{' '}
          allows you to update it in private. Customers can only see and order
          products that are <strong>Live</strong>.
        </p>
        <p>
          <em>
            <strong>Tip:</strong> If a Menu or Category is set to Draft, then
            all items within it will also become private, even if their status
            is Live. This is an easy way to hide and show categories or entire
            menus without editing every product within them.
          </em>
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function PreordersTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Preorders</TooltipHeader>
      <TooltipContent>
        <p>
          Preorders allow your customers to order at any time for collection.
          These orders appear in the "Preorders" Tab on the Live page
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function CustomisationTypeTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Customisation Type</TooltipHeader>
      <TooltipContent>
        <p>
          <strong>Single Choice</strong> allows a customer to pick only one item
          from the list.
          <br />
          <em>e.g. choosing a soft drink mixer for a spirit</em>
        </p>
        <p>
          <strong>Multiple Choice</strong> allows a customer to pick multiple
          items from the list.
          <br />
          <em>e.g. adding extra toppings to a pizza.</em>
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function LimitTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Limits</TooltipHeader>
      <TooltipContent>
        <p>
          Normally customers can pick as many items from a multiple choice list
          as they want. But you can restrict this by setting a limit on the
          entire group.
        </p>
        <p>
          You can also set individual limits for each choice too{' '}
          <em>
            (e.g. you might limit a group to 10, but there’s a specific choice
            that you also want to separately limit customers from picking)
          </em>
          .
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function VenueID() {
  return (
    <TooltipModal>
      <TooltipHeader>Venue ID</TooltipHeader>
      <TooltipContent>
        <p>Enter the ID of the venue you want to add.</p>
        <p>
          The venue owner must enable the 'Multi-venue' feature in their
          settings page. They will then see their Venue ID at the bottom of
          Multi-Vendor page.
        </p>

        <p>
          For example, you can see your Venue ID at the bottom of this page..
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}

export function OptionGroupsToolTip() {
  return (
    <TooltipModal>
      <TooltipHeader style={{ marginTop: '30px', marginBottom: '12px' }}>
        {' '}
        Customisation Options
      </TooltipHeader>
      <TooltipContent>
        <p>
          Give your customers the choice to order exactly what they want. Create
          Option Groups and link them to your products.
        </p>
        <em>
          <p>
            <b>For example:</b> Add pepperoni to a pizza with an ‘Extra
            Toppings’ group or choose soy milk in a coffee with a ‘Choose your
            milk’ group.
          </p>
        </em>
      </TooltipContent>
    </TooltipModal>
  );
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/TooltipModals/index.jsx